import React from 'react';
import {stringToHash} from "../utils/profile_picture";
import {useStoreProfile} from "../store";
import {themecolors} from "../utils/themecolors";

const ProfilePicture = ({ username, profilePicture, size = 24, fontSize = 13 }) => {

    const {theme} = useStoreProfile();

    const hash = stringToHash(username);
    const index = hash % 11;
    const items = ['333333', '1a1a40', '2f4f4f', '191970', '0f0f0f', '013220', '4b000f', '311b3f', '2a2a2a', '3b2f2f', '004b4f'];

    const firstLetter = username.charAt(0).toUpperCase();

    const showProfilePicture = profilePicture || !username;

    const deletedUrl = theme === "dark" ? "602nx5udNMeo" : "xy6YrBgZOgzh";

    return (
        <div style={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: showProfilePicture ? 'transparent' : `#${items[index]}`,
            overflow: 'hidden'
        }}>
            {showProfilePicture ? (
                <img
                    src={profilePicture || `https://media.scored.co/post/${deletedUrl}.png`}
                    alt={username}
                    style={{ width: '100%', height: '100%',   border: `1px solid 
                    ${theme === 'dark' ? themecolors.dark_background_3 : themecolors.light_border}` }}
                />
            ) : (
                <span style={{
                    color: 'white',
                    fontWeight: '500',
                    fontSize: `${fontSize}px`,
                }}>
          {firstLetter}
        </span>
            )}
        </div>
    );
};

export default ProfilePicture;